import React from 'react';
import PropTypes from 'prop-types';
import { mapCreatorConnect } from '../../higher-order-components';
import Select from 'react-select';
import { Row, Col, Panel, Button } from 'react-bootstrap';
import { ToggleSwitch, MarkerEditorIconModal, MarkerEditorInfoWindowModal } from 'components';

class MarkerEditor extends React.Component {
  constructor(props) {
    super(props);

    this.handleMapChange = this.handleMapChange.bind(this);
    this.handleToggleMoveable = this.handleToggleMoveable.bind(this);
  }

  handleMapChange({ value: new_map }) {
    const { current_map, current_feature } = this.props.mapCreator;
    const payload = {
      to_map_id: new_map,
      from_map_id: current_map._id,
      feature_id: current_feature.properties._id
    };
    this.props.sendSocketEmit(payload, 'move-map-feature');
  }
  handleToggleMoveable() {
    const { current_feature, current_map } = this.props.mapCreator;
    const updated_properties = {
      ...current_feature.properties,
      draggable: current_feature.properties.draggable == true ? false : true
    };
    this.props.updateCurrentMapFeature({ ...current_feature, properties: updated_properties }, current_map._id);
  }

  render() {
    const {
      current_map,
      maps_list,
      current_feature,
      current_feature_saved
    } = this.props.mapCreator;

    const { info_window_text, info_window_image_file } = current_feature_saved ? current_feature_saved.properties || {} : {};
    return (
      <div className='map-creator-marker-editor-container'>
        <h3 className='title'>Marker Editor</h3>
        <Row className='mb-md'>
          <Col xs={12}>
            <p className='title'>Parent Map</p>
            <Select
              options={maps_list.map(m => ({ value: m._id, label: m.properties.title }))}
              onChange={this.handleMapChange}
              value={current_map ? current_map._id : null}
              clearable={false}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12}>
            <p className='title'>Icon</p>
          </Col>
        </Row>
        <Row className='mt-md'>
          <Col xs={8} md={8}>
            <p>Fixed Position</p>
            <ToggleSwitch
              onClick={this.handleToggleMoveable}
              on_condition={current_feature && current_feature.properties.draggable != true}
              type='primary'
            />
          </Col>
          <Col xs={4} md={4}>
            <div
              className='marker-editor-icon-image'
              onClick={() => this.props.toggleShowMarkerEditorIconModal(true)}
              >
              <img src={current_feature_saved && current_feature_saved.properties.icon_file ? current_feature_saved.properties.icon_file.url : ''} />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12}>
            <p className='title'>Info Window Content</p>
            {!info_window_image_file && !info_window_text ? (
              <Button block onClick={() => this.props.toggleShowMarkerEditorInfoWindowModal(true)}>Create Info Window</Button>
            ) : (
              <div
                className='map-creator-marker-editor-info-window-editor'
                onClick={() => this.props.toggleShowMarkerEditorInfoWindowModal(true)}
                >
                <Panel>
                  <Row>
                    <Col xs={12} md={12}>
                      <p>{info_window_text != null && info_window_text != '' ? info_window_text : '(No Info Window Text)'}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={12}>
                      <div className='info-window-content-image'>
                        {info_window_image_file ? <img src={info_window_image_file.url} /> : <p>(No Info Window Image)</p>}
                      </div>
                    </Col>
                  </Row>
                </Panel>
              </div>
            )}
          </Col>
        </Row>
        <MarkerEditorIconModal />
        <MarkerEditorInfoWindowModal />
      </div>
    );
  }
}

export default mapCreatorConnect(MarkerEditor);



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/marker-editor.js